import moment from 'moment';
import { IJobCardV2 } from '~/types/models/jobCard';
import { ITimeReport } from '~/types/models/timeReport';
import { IJobItemRequest } from '~/types/request/jobItem';
import { TimeReportRequest } from '~/types/request/timeReport';
import { getUTCOffset } from '../date';

export const dateTimeFields = ['reportStartDateTime', 'reportEndDateTime', 'createdAt', 'updatedAt'];

class TimeReportAdapters {
  public static adaptToStartReportRequest(jobCard: IJobCardV2, item: IJobItemRequest, code: string): TimeReportRequest {
    const createdAt = moment().toDate().toISOString();
    const currentTime = moment();
    const timezoneOffset = currentTime.format('Z');

    return {
      jobCardId: jobCard._id,
      dmsJCEntry: jobCard.DMSJCEntry,
      jobItemType: item.jobItemType,
      jobItem: item.jobItem,
      reportType: code,
      reportStartDateTime: createdAt,
      timeZone: timezoneOffset,
    };
  }

  public static adaptReportFromClientToServer(report: Record<string, any>): any {
    const result: any = { ...report };

    Object.entries(report).forEach(([key, value]) => {
      if (dateTimeFields.includes(key) && value) {
        const adaptValue = moment(value).add(getUTCOffset(), 'millisecond').toISOString();
        result[key] = adaptValue.substring(0, adaptValue.length - 5);
      }
    });

    return result;
  }

  public static adaptReportFromServerToClient(report: ITimeReport): ITimeReport {
    const result: any = { ...report, jobItem: report.jobItem?._id || report.jobItem };

    Object.entries(report).forEach(([key, value]) => {
      if (dateTimeFields.includes(key) && value) {
        const adaptValue = value.includes('Z') ? value : `${value}.000Z`;
        result[key] = moment(adaptValue).subtract(getUTCOffset(), 'millisecond').toISOString();
      }
    });

    return result;
  }
}

export default TimeReportAdapters;
